import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { scrollToId } from "./scroll";

const LINKS = [
  { label: "Find Services", id: "services" },
  { label: "Locations", id: "areas" },
  { label: "How It Works", id: "how-it-works" },
  { label: "For Professionals", id: "professionals" },
  { label: "About Us", id: "about" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();
  const dashPath = user?.role === "professional" ? "/pro/dashboard" : "/dashboard";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };



  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled || open ? "bg-navy/90 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <button data-testid="nav-logo" onClick={() => go("hero")} className="flex items-center gap-3 text-left">
          <span className="w-9 h-9 bg-flame flex items-center justify-center font-heading font-black text-white text-xl">P</span>
          <span className="leading-none">
            <span className="block font-heading font-black text-white text-lg tracking-tight">PRIME PRO</span>
            <span className="block text-[10px] tracking-[0.3em] text-white/60 uppercase">Connect Services</span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm text-white/80 hover:text-flame transition-colors font-medium"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <button
              data-testid="nav-dashboard-btn"
              onClick={() => navigate(dashPath)}
              className="bg-flame hover:bg-flame-dark text-white text-sm font-heading font-bold uppercase tracking-wider px-6 py-3 transition-transform hover:scale-[1.03]"
            >
              My Dashboard
            </button>
          ) : (
            <>
              <button data-testid="nav-login-btn" onClick={() => navigate("/login")} className="text-sm text-white/80 hover:text-white px-4 py-2 transition-colors font-medium">
                Log In
              </button>
              <button
                data-testid="nav-join-btn"
                onClick={() => navigate("/join")}
                className="bg-flame hover:bg-flame-dark text-white text-sm font-heading font-bold uppercase tracking-wider px-6 py-3 transition-transform hover:scale-[1.03]"
              >
                Join Prime Pro
              </button>
            </>
          )}
        </div>

        <button data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} className="lg:hidden text-white p-2">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden bg-navy border-t border-white/10 px-6 py-6 flex flex-col gap-4">
          {LINKS.map((l) => (
            <button key={l.id} data-testid={`nav-mobile-${l.id}`} onClick={() => go(l.id)} className="text-white/90 text-left text-base py-1">
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-join"
            onClick={() => navigate(user ? dashPath : "/join")}
            className="bg-flame text-white font-heading font-bold uppercase tracking-wider px-6 py-3 mt-2"
          >
            {user ? "My Dashboard" : "Join Prime Pro"}
          </button>
        </div>
      )}
    </header>
  );
};

export default Navbar;
